import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import humanTime from 'flarum/common/helpers/humanTime';
import username from 'flarum/common/helpers/username';
import ItemList from 'flarum/common/utils/ItemList';
import extractText from 'flarum/common/utils/extractText';
import sortTags from 'ext:flarum/tags/common/utils/sortTags';
import SublaceHero from './SublaceHero';
import ForumsSidebar from './ForumsSidebar';
import { sublace, formatNumber, statusOf, StatusLabel } from '../../common/sublace';
import { loadOverview, overview } from '../states/overview';
import startDiscussion from '../startDiscussion';
const INCLUDES = 'children,parent,lastPostedDiscussion,lastPostedDiscussion.lastPostedUser';

/**
 * Главная «Форумы»: категории и разделы списком, как на XenForo-форумах
 * (AgeraPvP и т. п.), с числом тем и сообщений и последней темой.
 */
export default class ForumsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--sublaceForums';
    app.history.push('sublace.forums', 'Форумы');
    app.current.set('noTagsList', true);
    this.loading = !app.store.all('tags').length;
    app.store.find('tags', {
      include: INCLUDES
    }).then(() => {
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
    loadOverview();
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle('Форумы');
    app.setTitleCount(0);
  }
  view() {
    const config = sublace();
    return m("div", {
      className: "SublaceForumsPage"
    }, config.heroEnabled !== false ? m(SublaceHero, null) : null, m("div", {
      className: "container SublaceForumsPage-container"
    }, m("main", {
      className: "SublaceForums-main",
      id: "main-content"
    }, this.toolbar(), this.loading ? m(LoadingIndicator, {
      display: "block"
    }) : this.categories()), m("aside", {
      className: "SublaceForums-aside"
    }, m(ForumsSidebar, null))));
  }
  toolbar() {
    return m("div", {
      className: "SublaceForums-toolbar"
    }, m("h2", {
      className: "SublaceForums-heading"
    }, "\u0424\u043E\u0440\u0443\u043C\u044B"), m("div", {
      className: "SublaceForums-toolbarActions"
    }, m(Link, {
      className: "Button SublaceButton SublaceButton--ghost",
      href: app.route('index')
    }, m(Icon, {
      name: "fas fa-bolt"
    }), " \u0427\u0442\u043E \u043D\u043E\u0432\u043E\u0433\u043E"), app.session.user && app.session.user.unreadNotificationCount && app.session.user.unreadNotificationCount() ? m(Link, {
      className: "Button SublaceButton SublaceButton--ghost",
      href: app.route('notifications')
    }, m(Icon, {
      name: "fas fa-bell"
    }), " \u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F") : null));
  }
  categories() {
    const all = app.store.all('tags');
    const roots = sortTags(all.filter(tag => tag.position() !== null && !tag.isChild()));
    const cloud = all.filter(tag => tag.position() === null);
    if (!roots.length) {
      return m("div", {
        className: "SlEmpty"
      }, m(Icon, {
        name: "fas fa-layer-group"
      }), m("p", null, "\u0420\u0430\u0437\u0434\u0435\u043B\u044B \u0435\u0449\u0451 \u043D\u0435 \u0441\u043E\u0437\u0434\u0430\u043D\u044B."), app.session.user && app.session.user.isAdmin && app.session.user.isAdmin() ? m("a", {
        className: "Button Button--primary",
        href: app.forum.attribute('adminUrl') + '#/sublace'
      }, "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u0430\u043D\u0435\u043B\u044C SUBLACE") : null);
    }
    return [roots.map(root => this.category(root)), cloud.length ? m("section", {
      className: "SlCategory SlCategory--cloud"
    }, m("header", {
      className: "SlCategory-header"
    }, m("div", {
      className: "SlCategory-titles"
    }, m("h3", {
      className: "SlCategory-title"
    }, "\u041C\u0435\u0442\u043A\u0438"))), m("div", {
      className: "SlCloud"
    }, cloud.map(tag => m(Link, {
      className: "SlCloud-tag",
      href: app.route.tag(tag),
      style: {
        '--tag-color': tag.color() || 'var(--sl-violet)'
      }
    }, tag.name())))) : null];
  }
  category(root) {
    const children = sortTags((root.children() || []).filter(Boolean));
    const rows = children.length ? children : [root];
    return m("section", {
      className: "SlCategory",
      style: {
        '--tag-color': root.color() || 'var(--sl-violet)'
      }
    }, m("header", {
      className: "SlCategory-header"
    }, m("span", {
      className: "SlCategory-icon"
    }, root.icon() ? m(Icon, {
      name: root.icon()
    }) : m(Icon, {
      name: "fas fa-folder"
    })), m("div", {
      className: "SlCategory-titles"
    }, m("h3", {
      className: "SlCategory-title"
    }, m(Link, {
      href: app.route.tag(root)
    }, root.name())), root.description() ? m("p", {
      className: "SlCategory-description"
    }, root.description()) : null)), m("ul", {
      className: "SlNodeList"
    }, rows.map(tag => this.node(tag))));
  }
  node(tag) {
    const data = overview();
    const posts = data && data.tagPosts ? data.tagPosts[tag.id()] || 0 : null;
    const last = tag.lastPostedDiscussion && tag.lastPostedDiscussion();
    const config = (sublace().tagConfig || {})[tag.id()];
    const canStart = tag.canStartDiscussion ? tag.canStartDiscussion() : false;
    return m("li", {
      className: 'SlNode' + (tag.isRestricted && tag.isRestricted() ? ' SlNode--restricted' : ''),
      style: {
        '--tag-color': tag.color() || 'var(--sl-violet)'
      }
    }, m("span", {
      className: "SlNode-icon"
    }, tag.icon() ? m(Icon, {
      name: tag.icon()
    }) : m(Icon, {
      name: "far fa-comments"
    })), m("div", {
      className: "SlNode-main"
    }, m(Link, {
      className: "SlNode-title",
      href: app.route.tag(tag)
    }, tag.name()), tag.description() ? m("div", {
      className: "SlNode-description"
    }, tag.description()) : null, m("div", {
      className: "SlNode-meta"
    }, config && config.template ? m("span", {
      className: "SlNode-chip"
    }, m(Icon, {
      name: "far fa-file-alt"
    }), " \u041F\u043E\u0434\u0430\u0447\u0430 \u043F\u043E \u0444\u043E\u0440\u043C\u0435") : null, tag.isRestricted && tag.isRestricted() && !canStart ? m("span", {
      className: "SlNode-chip SlNode-chip--muted"
    }, m(Icon, {
      name: "fas fa-lock"
    }), " \u0422\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u0430") : null, canStart && config && config.template ? m(Button, {
      className: "Button Button--link SlNode-create",
      icon: "fas fa-plus",
      onclick: () => this.create(tag)
    }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0442\u0435\u043C\u0443") : null)), m("dl", {
      className: "SlNode-stat"
    }, m("dt", null, "\u0422\u0435\u043C\u044B"), m("dd", null, formatNumber(tag.discussionCount() || 0))), m("dl", {
      className: "SlNode-stat"
    }, m("dt", null, "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F"), m("dd", null, posts === null ? '—' : formatNumber(posts))), m("div", {
      className: "SlNode-last"
    }, last ? this.lastPost(last) : m("span", {
      className: "SlNode-lastEmpty"
    }, "\u0422\u0435\u043C \u043F\u043E\u043A\u0430 \u043D\u0435\u0442")));
  }
  lastPost(discussion) {
    const user = discussion.lastPostedUser && discussion.lastPostedUser();
    const status = statusOf(discussion.sublaceStatus && discussion.sublaceStatus());
    return m(Link, {
      className: "SlLast",
      href: app.route.discussion(discussion, discussion.lastPostNumber() || undefined)
    }, m("span", {
      className: "SlLast-title"
    }, status ? m(StatusLabel, {
      status: status,
      small: true
    }) : null, discussion.title()), m("span", {
      className: "SlLast-meta"
    }, discussion.lastPostedAt() ? humanTime(discussion.lastPostedAt()) : null, user ? [' · ', m("span", {
      className: "SlLast-user"
    }, username(user))] : null));
  }
  create(tag) {
    const parent = tag.parent && tag.parent();
    startDiscussion(parent ? [parent, tag] : [tag]);
  }
}
flarum.reg.add('sublace-forum', 'forum/components/ForumsPage', ForumsPage);